import { CsatProvider } from './CsatProvider';

let provider: CsatProvider | null = null;

let pendingCsatResponseContext: Record<string, string> | null = null;

let pendingCsatPrepareSurveyConfig: unknown = null;

/** Queue traits until `setCsatProvider` registers an instance (start can resolve before SDK init). */
export const enqueuePendingCsatResponseContext = (traits: Record<string, string>) => {
    pendingCsatResponseContext = traits;
};

/** Queue survey config until `setCsatProvider` registers an instance (start can resolve before SDK init). */
export const enqueuePendingCsatPrepareSurvey = (config: unknown) => {
    pendingCsatPrepareSurveyConfig = config;
};

export const setCsatProvider = (nextProvider: CsatProvider | null) => {
    provider = nextProvider;
    if (!nextProvider) {
        pendingCsatResponseContext = null;
        pendingCsatPrepareSurveyConfig = null;
        return;
    }
    if (pendingCsatResponseContext) {
        nextProvider.setResponseContext(pendingCsatResponseContext);
        pendingCsatResponseContext = null;
    }
    if (pendingCsatPrepareSurveyConfig != null) {
        nextProvider.prepareSurvey(pendingCsatPrepareSurveyConfig);
        pendingCsatPrepareSurveyConfig = null;
    }
};

export const getCsatProvider = (): CsatProvider | null => provider;
